
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/localList.m",
      function () {
        return require("private-next-pages/product/localList.m.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/localList.m"])
      });
    }
  